module.exports = __webpack_public_path__ + "static/web-b4641f61b9e07379fabc5b038421f60e.jpg";